import React from "react";
import {
	Button,
	Dialog,
	DialogContent,
	DialogActions,
	DialogTitle,
	TextField
} from "@material-ui/core";

function ChangeReasonModal({ isOpen, onSave, onCancel, reason, onReasonChange, ...props }) {
	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			onSave();
		}
	};

	return (
		<Dialog open={isOpen} onClose={onCancel} fullWidth {...props}>
			<DialogTitle>
				Change Reason
			</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					fullWidth
					multiline
					rows={3}
					value={reason}
					onChange={onReasonChange}
					label="Why are you making this change?"
					margin="normal"
					variant="outlined"
					onKeyPress={handleKeyPress}
					placeholder="Optional: Describe what changed and why..." />
			</DialogContent>
			<DialogActions>
				<Button size="small" color="primary" onClick={onSave}>
					Save
				</Button>
				<Button size="small" color="secondary" onClick={onCancel}>
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ChangeReasonModal;
